import React from 'react'
import s from './GeoentityBlockSource.less'
import { capitalize } from '../../../utils/string'
import useTagBiForGeoentity from '../useTagBiForGeoentity'
import { getImageUrl } from '../../utils/image'

const GeoentityBlockSource = props => {
  const { label, logo, templatizedUrl, tag } = props.data
  const sendSourceBiTagNow = useTagBiForGeoentity(tag)

  return (
    <div className={s.title}>
      <span className={s.titleBook}>{capitalize(label)}</span>
      <a href={templatizedUrl} target="_blank" rel="noreferrer noopener" onClick={() => sendSourceBiTagNow()}>
        <img className={s.titleLogo} src={getImageUrl(logo)} />
      </a>
    </div>
  )
}

export default GeoentityBlockSource
